<template>
  <div id="nodata">
    <article>
      <touch class="music" :class="{ active: musicPlaying }" @tap="playOrPause"></touch>
      <div class="page-inner">
        <div class="data">
          <p>2017年，<br><strong class="name">{{ name }}</strong> 同志日理万机，<br>疏忽了英语水平的提升……</p>
        </div>
        <div class="comment">
          <p><strong>2018年百废待兴，<br>望你扛起学习的大旗！</strong></p>
        </div>
        <div class="poster">
          <webp-image src="https://cdn.llscdn.com/fe-static/campaigns/annual-summary-2017/2-77PVmV1x.png" />
        </div>
      </div>
    </article>
  </div>
</template>

<script>
  import WebpImage from '@/components/common/WebpImage'

  export default {
    name: 'page-nodata',
    computed: {
      name () {
        return this.$store.state.data.nick
      },
      musicPlaying () {
        return this.$store.state.musicPlaying
      }
    },
    created () {
      this.$track.sendPageTrack('report_no_result')
    },
    methods: {
      playOrPause () {
        this.$emit('playOrPauseBgMusic')
      }
    },
    components: {
      WebpImage
    }
  }
</script>

<style lang="scss">
  $paper: 'https://cdn.llscdn.com/fe-static/campaigns/annual-summary-2017/paper-WtxrklAJ.png';
  $border: 'https://cdn.llscdn.com/fe-static/campaigns/annual-summary-2017/border-UcNzeP9P.png';

  #nodata {
    article {
      @include bg-image-contain($paper);
      width: 750px;
      height: 1188px;
      padding-left: 60px;
      padding-right: 60px;
      padding-top: 126px;
      box-sizing: border-box;
      .page-inner {
        @include bg-image-contain($border);
        position: relative;
        width: 644px;
        height: 1027px;
        padding: 80px 45px;
        box-sizing: border-box;
        p {
          font-size: 35px;
          color: $red;
          line-height: 50px;
          strong {
            font-size: 40px;
            color: $darkBlue;
          }
        }
        .poster {
          position: absolute;
          left: 45px;
          bottom: 74px;
          width: 550px;
          font-size: 0;
        }
      }
      .name {
        font-family: Helvetica,Tahoma,Arial,'PingFang SC','Microsoft YaHei','Hiragino Sans GB',SimSun,Heiti,sans-serif;
      }
      .comment {
        margin-top: 136px;
        font-size: 50px;
        color: $darkBlue;
        text-align: center;
        line-height: 60px;
      }
    }
  }
  body[data-webp='support'] {
    #nodata {
      article {
        background-image: url($paper + '?imageMogr2/format/webp');
        .page-inner {
          background-image: url($border + '?imageMogr2/format/webp');
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Nodata.vue